export const getAuthToken = (): string | null => {
  const token = localStorage.getItem('token');
  if (!token) {
    console.warn('No authentication token found in localStorage');
  }
  return token;
};

export const getAuthHeaders = () => {
  const token = getAuthToken();
  if (!token) {
    console.error('Cannot create auth headers: No token available');
    return {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };
  }

  // Remove any 'Bearer ' prefix if it exists in the stored token
  const cleanToken = token.replace('Bearer ', '');
  
  return {
    'Authorization': `Bearer ${cleanToken}`,
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };
};

// Function to decode JWT and get user role
export const getUserRole = (): { isAdmin: boolean, isMaintainer: boolean } => {
  const token = getAuthToken();
  if (!token) {
    return { isAdmin: false, isMaintainer: false };
  }
  
  try {
    // Split the token and get the payload part
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    const decodedToken = JSON.parse(jsonPayload);
    
    // Check if user has ADMIN or MAINTAINER role
    const isAdmin = decodedToken?.role?.authority === 'ADMIN';
    const isMaintainer = decodedToken?.role?.authority === 'MAINTAINER';
    
    return { isAdmin, isMaintainer };
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return { isAdmin: false, isMaintainer: false };
  }
}; 